import { Typography } from '@mui/material';
import { styled } from '@mui/material/styles';

export const AutoStaffText = styled(Typography)(({ theme, disabled }) => ({
  fontSize: 'inherit',
  fontWeight: 'inherit',
  lineHeight: 'inherit',
  ...(disabled
    ? {
        color: theme.palette.action.disabled,
      }
    : {
        background: 'linear-gradient(90deg, #FF7998 0.29%, #C73B86 32.16%, #871D75 57.6%, #C73B86 74.27%)',
        backgroundClip: 'text',
        WebkitBackgroundClip: 'text',
        WebkitTextFillColor: 'transparent',
      }),
}));
